(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
